const ProductionUpdateType = {
  Resource: 0,
  Hub: 1,
  values: () => Object.values(ProductionUpdateType).filter(obj => typeof obj === 'number'),
  isValid: (value) => ProductionUpdateType.values().includes(value)
};

export { ProductionUpdateType };